import PropTypes from 'prop-types';

function ActivateMembershipPricing({ annualPlusMembershipCost, availableTrialMembership }) {
    return (
        <div className="justify-between gap-10 md:flex">
            {availableTrialMembership ? (
                <>
                    <span className="text-plus-membership font-grotesk-bold">
                        Free {availableTrialMembership?.trialDurationDays}-day trial
                    </span>
                    <p>Then ${annualPlusMembershipCost}/year</p>
                </>
            ) : (
                <>
                    <p>
                        <span className="font-grotesk-bold">${annualPlusMembershipCost} per year</span> | Billed
                        annually
                    </p>
                    <p className="ml-auto text-grey">
                        That’s just ${(annualPlusMembershipCost / 12)?.toFixed(2)} per month!
                    </p>
                </>
            )}
        </div>
    );
}

ActivateMembershipPricing.propTypes = {
    annualPlusMembershipCost: PropTypes.number.isRequired,
    availableTrialMembership: PropTypes.shape({
        trialDurationDays: PropTypes.number,
    }),
};

ActivateMembershipPricing.defaultProps = {
    availableTrialMembership: null,
};

export { ActivateMembershipPricing };
